/* Copyright (c) Epiphyte LLC 2022. All rights reserved.
Author: Fernandez-Alcon, Jose <jose@epiphyte.io>
 */

import React from "react";
import {
    Card,
    Button,
    CardBody,
    CardHeader,
    CardFooter,
    Paragraph,
    Heading,
    Image,
    Menu,
} from "grommet";
import { Edit, Trash } from 'grommet-icons'
import {
    deleteProduce
} from "API/API";


type Props = {
    refreshFunc: () => {},
    Image: string,
    Title: string,
    Description: string,
    ProduceID: string,
}

const ProduceCard: React.FC<Props> = (props) => {

    console.log(props.Image)
    // const image = "https://images.unsplash.com/photo-1522184216316-3c25379f9760?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3870&q=80"

    const removeProduce = () => {
        deleteProduce(props.ProduceID).then(err => {
            console.log(err)
            props.refreshFunc()
        })
    }

    return (
        <Card
            width={"medium"}
        >
            <CardHeader>
                <Image
                    fit="cover"
                   src={"https://produceimages.vegg.it/"+ props.Image}// src={props.Image}
                />
            </CardHeader>
            <CardBody
                pad={"small"}
            >
                <Heading
                    color={"brand"}
                    level={3}
                >{props.Title}</Heading>
                <Paragraph>
                    {props.Description}
                </Paragraph>
            </CardBody>
            <CardFooter>
                <Button icon={<Edit />} hoverIndicator />
                <Button icon={<Trash />} hoverIndicator onClick={removeProduce} />
            </CardFooter>
        </Card>
    )

}

export default ProduceCard
